let language = {
    "ESHOPER-BUSINESS-FORM-TITLE": "Partner Information",
    "ESHOPER-BUSINESS-FORM-NAME": "Business name",
    "ESHOPER-BUSINESS-TIPS-APPEAR": "This information will appear on your invoices",
    "ESHOPER-BUSINESS-FORM-TIPS-NAME": "Business name is required",
    "ESHOPER-BUSINESS-FORM-CONTACT": "Contact details",
    "ESHOPER-BUSINESS-FORM-FULL-NAME": "Full Name",
    "ESHOPER-BUSINESS-FORM-FULL-NAME-TIPS": "Contact Person is required",
    "ESHOPER-BUSINESS-FORM-COUNTRY-CODE": "Country code",
    "ESHOPER-BUSINESS-FORM-COUNTRY-CODE-TIPS": "Country code is required",
    "ESHOPER-BUSINESS-FORM-COUNTRY-CODE-TIPS-INVALID": "Invalid country code",
    "ESHOPER-BUSINESS-FORM-PHONE": "Phone",
    "ESHOPER-BUSINESS-FORM-PHONE-TIPS": "Phone is required",
    "ESHOPER-BUSINESS-FORM-PHONE-TIPS-INVALID": "Invalid phone",
    "ESHOPER-BUSINESS-FORM-EMAIL": "Email",
    "ESHOPER-BUSINESS-FORM-EMAIL-TIPS": "Email is required",
    "ESHOPER-BUSINESS-FORM-EMAIL-TIPS-INVALID": "Invalid Email",
    "ESHOPER-BUSINESS-FORM-ADDRESS": "Address",
    "ESHOPER-BUSINESS-FORM-REGION": "Country / Region",
    "ESHOPER-BUSINESS-FORM-REGION-TIPS": "Country/Region is required",
    "ESHOPER-BUSINESS-FORM-RESULT-EMPTY": "No results match",
    "ESHOPER-BUSINESS-FORM-STATE": "State / Province",
    "ESHOPER-BUSINESS-FORM-STATE-TIPS": "State / Province is required",
    "ESHOPER-BUSINESS-FORM-CITY": "City / Town",
    "ESHOPER-BUSINESS-FORM-CITY-TIPS": "City is required",
    "ESHOPER-BUSINESS-FORM-POSTAL-CODE": "Postal code",
    "ESHOPER-BUSINESS-FORM-POSTAL-CODE-TIPS": "Postal code is required",
    "ESHOPER-BUSINESS-FORM-POSTAL-CODE-TIPS-INVALID": "Invalid postal code",
    "ESHOPER-BUSINESS-FORM-ADDRESS1": "Address 1",
    "ESHOPER-BUSINESS-FORM-ADDRESS1-TIPS": "Address is required",
    "ESHOPER-BUSINESS-FORM-ADDRESS2": "Address 2",
    "ESHOPER-BUSINESS-FORM-SAVE-BUTTON": "Save",
    "ESHOPER-BUSINESS-FORM-ESHOP": "E-shop",
    "ESHOPER-BUSINESS-FORM-ESHOP-RETURN-ADDRESS": "Return Address",
    "ESHOPER-BUSINESS-FORM-ESHOP-RETURN-ADDRESS-TIPS": "This address is for your customers to return products to you",
    "ESHOPER-BUSINESS-FORM-ESHOP-RETURN-ADDRESS-EMPTY": "No return address",
    "ESHOPER-BUSINESS-FORM-ESHOP-PLACEHOLDER-COUNTRY": "Search Country",
    "ESHOPER-BUSINESS-FORM-ESHOP-PLACEHOLDER-STATE": "Search State / Province",
    "ESHOPER-BUSINESS-FORM-ESHOP-PLACEHOLDER-CITY": "City",
    "ESHOPER-BUSINESS-FORM-ESHOP-PLACEHOLDER-POSTAL-CODE": "Postal code",
};

export { language }